import { formatNumber, formatPercent } from '/b2b/common/helpers/Number';

import { LegendIcon } from '/b2b/common/components/Charts';
import camelCase from 'lodash/camelCase';
import { locale } from '/b2b/common/helpers/i18n';
import moment from 'moment';

export const FILTER_KEYS = ['dateRange', 'forms', 'jurisdictions', 'requestTypes'];

export const BAR_CHART_TOOLTIP = {
    confine: true,
    trigger: 'axis',
    axisPointer: {
        type: 'none',
    },
    formatter(params) {
        // For stacked bar charts, calculate the total and percentage for each series
        if (params.length > 1) {
            const values = {};
            let total = 0;
            let interval;

            params.forEach(param => {
                const valueKey = camelCase(param.seriesName);
                const value = param.data[valueKey];
                values[valueKey] = value;
                total += value;
                interval = param?.data?.interval || 'day';
            });

            // Format the date, check if dates are truncated by day, month, or year
            let dateFormat = 'MMM, YYYY';
            switch (interval) {
                case 'day':
                    dateFormat = 'MMM D, YYYY';
                    break;
                case 'month':
                    dateFormat = 'MMM, YYYY';
                    break;
                case 'year':
                    dateFormat = 'YYYY';
                    break;
            }

            let date;
            try {
                date = moment(params[0].axisValueLabel).format(dateFormat);
            } catch {
                date = params[0].axisValueLabel;
            }

            const loc = locale();
            let tooltipText = `<b>${date} (${formatNumber(total, loc)})</b><br/>`;

            params.forEach(param => {
                const valueKey = camelCase(param.seriesName);
                const value = values[valueKey];
                const percent = total > 0 ? (value / total) * 100 : 0;
                tooltipText += `${param.marker} ${param.seriesName}: <b>${formatPercent(percent, loc, 0)}</b> (${formatNumber(value, loc)})<br/>`;
            });

            return tooltipText;
        }

        // If there's only one item, use the default formatter
        const loc = locale();
        const valueKey = params[0].dimensionNames?.[1] || camelCase(params[0].seriesName);
        const value =
            typeof params[0].value === 'object' ? params[0].data[valueKey] : params[0].value;

        const singleInterval = params[0].data?.interval || 'day';
        let singleDateFormat = 'MMM D, YYYY';
        if (singleInterval === 'month') {
            singleDateFormat = 'MMM, YYYY';
        } else if (singleInterval === 'year') {
            singleDateFormat = 'YYYY';
        }

        let singleDate;
        try {
            singleDate = moment(params[0].axisValueLabel).format(singleDateFormat);
        } catch {
            singleDate = params[0].axisValueLabel;
        }

        return `<b>${singleDate}</b><br/>${params[0].marker} ${params[0].seriesName}: <b>${formatNumber(value, loc)}</b>`;
    },
};

export const COMMON_OPTIONS = {
    grid: {
        containLabel: true,
    },
    legend: {
        icon: LegendIcon,
        orient: 'horizontal',
        top: 'top',
    },
    xAxis: {
        axisLine: { show: true },
        axisTick: { show: false },
        splitLine: { show: false },
    },
    yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: true },
    },
    useUTC: true,
};

export const TIME_XAXIS_OPTIONS = {
    xAxis: {
        type: 'time',
        axisLabel: {
            interval: 'auto',
            hideOverlap: true,
            formatter: {
                day: '{MMM}, {dd}',
                month: '{MMM}, {yyyy}',
                year: '{yyyy}',
            },
        },
    },
};

export const VERTICAL_YAXIS_OPTIONS = {
    grid: {
        containLabel: true,
    },
    yAxis: {
        minInterval: 1,
        nameLocation: 'middle',
        nameTextStyle: {
            fontWeight: 'bold',
        },
    },
};
